// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 1.06189C7.05369 1.55399 4 4.92038 4 9H11V1.06189Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 1.06189V9H20C20 4.92038 16.9463 1.55399 13 1.06189Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 11H4V15C4 19.4183 7.58172 23 12 23C16.4183 23 20 19.4183 20 15V11Z"}}]};

const MouseFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mouse-filled',
    ref,
    icon: element,
  },
));

MouseFilledIcon.displayName = 'MouseFilledIcon';

export default MouseFilledIcon;
